import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { CheckSquare, Plus, FolderOpen, Timer } from 'lucide-react';

function TasksSidebar({ quickTasks, onAddTask, onStartPomodoro, onNewProject }) {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 1: return 'text-red-600 bg-red-50 border-red-200 dark:text-red-400 dark:bg-red-900/20 dark:border-red-800';
      case 2: return 'text-orange-600 bg-orange-50 border-orange-200 dark:text-orange-400 dark:bg-orange-900/20 dark:border-orange-800';
      case 3: return 'text-blue-600 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-900/20 dark:border-blue-800';
      case 4: return 'text-gray-600 bg-gray-50 border-gray-200 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700';
      case 5: return 'text-gray-500 bg-gray-25 border-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700';
      default: return 'text-blue-600 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-900/20 dark:border-blue-800';
    }
  };

  const getPriorityText = (priority) => {
    switch (priority) {
      case 1: return 'Critical';
      case 2: return 'High';
      case 3: return 'Medium';
      case 4: return 'Low';
      case 5: return 'Lowest';
      default: return 'Medium';
    }
  };

  return (
    <div>
      {/* Recent Tasks Section */}
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center">
          <CheckSquare className="w-5 h-5 mr-2 text-red-600" />
          Recent Tasks
        </h2>
        <Button variant="outline" size="sm">
          View All
        </Button>
      </div>

      <div className="space-y-3">
        {quickTasks.map((task) => (
          <Card key={task.id} className="hover:shadow-md transition-shadow cursor-pointer">
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="font-medium text-gray-900 dark:text-white mb-1">{task.name}</h4>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {task.projects?.name} • {task.projects?.project_groups?.name}
                  </p>
                </div>
                <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getPriorityColor(task.priority)}`}>
                  {getPriorityText(task.priority)}
                </span>
              </div>
            </CardContent>
          </Card>
        ))}

        {quickTasks.length === 0 && (
          <Card className="border-dashed border-2 border-gray-300 dark:border-gray-600">
            <CardContent className="flex flex-col items-center justify-center py-8 text-center">
              <CheckSquare className="w-8 h-8 text-gray-400 mb-2" />
              <p className="text-gray-600 dark:text-gray-300 font-medium">No recent tasks</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Create your first task to get started</p>
            </CardContent>
          </Card>
        )}
      </div>

      {/* Quick Actions */}
      <Card className="mt-6">
        <CardHeader>
          <CardTitle className="text-lg">Quick Actions</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button variant="outline" className="w-full justify-start" onClick={onAddTask}>
            <Plus className="w-4 h-4 mr-2" />
            Add Task
          </Button>
          <Button variant="outline" className="w-full justify-start" onClick={onNewProject}>
            <FolderOpen className="w-4 h-4 mr-2" />
            New Project
          </Button>
          <Button variant="outline" className="w-full justify-start" onClick={onStartPomodoro}>
            <Timer className="w-4 h-4 mr-2" />
            Start Pomodoro
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default TasksSidebar;
